module.exports = __webpack_public_path__ + "src/components/Loading/loading.svg?f767f0b6";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/loading.svg
// module id = 2809
// module chunks = 1